import { useSigningState } from '@modusign/react-signing/setup';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { useMount, useUnmount } from 'react-use';

import { DocumentHistoryState } from '@app/features/documents/types';
import { usePDF } from '@app/hooks/usePDF';
import documentAuthService from '@app/libs/auth/documentAuthService';
import { initializeContractAuthentication } from '@app/store/contract-authentication/actions';

interface DocumentLayoutProps {
  children: ReactNode;
}

const defaultProps = {
  children: null,
};

// "/document/completed", "/document/wait-for-signing" 등 특정 문서의 상태별 UI를 보여주는 route들을 위한 layout 컴포넌트입니다.
// "/document/:documentId"의 동적 route에는 사용하지 않습니다.
export function DocumentLayout({ children }: DocumentLayoutProps) {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { initialize } = useSigningState();
  const { resetPDF } = usePDF();
  const { state } = useLocation<DocumentHistoryState>();
  const history = useHistory();

  // location state에 documentId가 없다면 튕겨냅니다.
  if (!state?.documentId) {
    history.replace('/');
  }

  useUnmount(() => {
    documentAuthService.restoreTokens();
    dispatch(initializeContractAuthentication());
  });

  useMount(() => {
    dispatch(initializeContractAuthentication());
  });

  useUnmount(() => {
    initialize();
    resetPDF();
    i18n.changeLanguage('ko');
  });

  return <div className="Background Background--dark-gray">{children}</div>;
}

DocumentLayout.defaultProps = defaultProps;

export default DocumentLayout;
